import {
  Component,
  PLATFORM_ID,
  inject,
  signal,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { Store } from "@ngrx/store";

import { CoreActions } from "src/app/core/store/actions";
import { Seo } from "src/app/core/services/seo.service";
import { environment } from "src/environments/environment";
import { NgClass, KeyValuePipe } from "@angular/common";

@Component({
  selector: "audio-notice",
  templateUrl: "./notice.component.html",
  styleUrls: ["./notice.component.sass"],
  imports: [NgClass, RouterLink, KeyValuePipe],

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoticeComponent {
  private store = inject<Store>(Store);
  private seo = inject(Seo);
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  platformId = inject(PLATFORM_ID);

  public pages = new Map([
    ["identite-entreprise", { title: "Identité de l'entreprise" }],
    [
      "conditions-generales",
      {
        title: "Conditions générales de location",
        description: "Retrouvez nos conditions générales de location.",
      },
    ],
    // [
    //   "confidentialite",
    //   {
    //     title: "Confidentialité",
    //     description: "Accord de confidentialité et traitement des données.",
    //   },
    // ],
  ]);
  public $path = signal<string | null>(null);

  constructor() {
    this.route.paramMap.subscribe((params) => {
      this.$path.set(params.get("page"));
      const page = this.$path() && this.pages.get(this.$path()!);
      if (page) {
        this.seo.setMeta({ property: "og:type", content: "website" });
        this.seo.setTitle(`${page.title} | ${environment.title}`);
        this.seo.setDescription(page.description);
        this.seo.setImage(
          environment.fullUrl + "/assets/imgs/sonorisation-fontevraud.jpg",
        );
        this.store.dispatch(
          new CoreActions.SetBreadcrumb({
            label: page.title,
            slug: `legal/${params.get("page")}`,
            entity: "page",
          }),
        );
      } else {
        this.router.navigate(["/legal/identite-entreprise"]);
      }
    });
  }

  unsorted(_a: unknown, _b: unknown) {
    return 1;
  }
}
